"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTaskViewTableQueryState = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const utils_1 = require("../../../../hooks/product-table-dynamic-columns/utils");
const getTaskViewTableQueryState = ({ dynamicColumns, filter, pageSize, search, sort, }) => ({
    [view_query_params_1.ViewQueryStateField.Filter]: filter,
    [view_query_params_1.ViewQueryStateField.Search]: search,
    [view_query_params_1.ViewQueryStateField.Sort]: sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: pageSize,
    [view_query_params_1.ViewQueryStateField.DynamicColumns]: (0, utils_1.compactDynamicColumnsForViewQueryState)(dynamicColumns),
});
exports.getTaskViewTableQueryState = getTaskViewTableQueryState;
